import { gql } from '@apollo/client';

export const UPDATE_APP_CONFIG = gql(/* GraphQL */ `
    mutation UpdateAppConfig($input: UpdateAppConfigInput!) {
        updateAppConfig(input: $input) {
            maintenanceMode
            maintenanceMessage
            surveyAutoGenEnabled
            surveyAutoGenDueDays
            vatPercentage
            divisionManagerApprovalSlaMinutes
            opsExecApprovalSlaMinutes
            seniorOpsExecApprovalSlaMinutes
            procurementManagerApprovalSlaMinutes
            procurementExecApprovalSlaMinutes
            procurementSupplierEngagementSlaMinutes
            androidAppVersion
            iosAppVersion
            huaweiAppVersion
            appUpdateRequired
            appUpdateMessage
            excludedCountryCodes
            excludedDivisionSapIds
            dailyIncompleteSalesReportRecipients
            dmOpsDeclineReasons
            procurementDeclineReasons
            supplierDeclineReasons
            interimPriceReasons
            salesReviewEnabled
            manualSalesAutoDataMaxAgeHours
            pendingPriceChangeRequestsDigestHours
            divisionalManagerPendingPriceChangeRequestsDigestHours
            divisionalManagerPriceChangeRequestOutcomesDigestHours
            storeManagerPriceChangeRequestOutcomesDigestHours
            pricingBatchesModuleEnabled
            priceChangeFreezeStartAt
            priceChangeFreezeEndAt
            priceChangeFreezeBannerMessage
            priceChangeFreezeIsActive
            salesDataMaintenanceStartTime
            salesDataMaintenanceEndTime
            letsCreatePriceSyncEnabled
            trainingModuleEnabled
        }
    }
`);
